// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAEVTHQAhu8zkxh3Zx-62obP0McJqdA_9s",
  authDomain: "uniquehomepatientcare.firebaseapp.com",
  projectId: "uniquehomepatientcare",
  storageBucket: "uniquehomepatientcare.appspot.com",
  messagingSenderId: "6216917566",
  appId: "1:6216917566:web:e0d30c3236a595fe4ce76f",
  measurementId: "G-R01Q31V9S8",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const messaging = getMessaging(app);
export { db, analytics, messaging };
